module.exports = __webpack_public_path__ + "img/avatar6.d1cbca94.png";